import React, { Dispatch, SetStateAction } from 'react'

import { Button } from '../..'
import { useProfileForm, useUser } from '../../../context'

const ButtonsSection = ({
  showCredentials,
  setShowCredentials,
}: {
  showCredentials: boolean
  setShowCredentials: Dispatch<SetStateAction<boolean>>
}) => {
  const { values, save, create, isDirty, loading, cancel, isNewUser } =
    useProfileForm()
  const { user, onEditionMode } = useUser()

  return (
    onEditionMode && (
      <>
        {!showCredentials && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              // alignItems: 'center',
              gap: 20,
            }}
          >
            {values.uid === user?.uid && (
              <Button
                className="light-blue"
                onClick={() => setShowCredentials(!showCredentials)}
                label="Cambiar credenciales de acceso"
                fontSize={16}
              />
            )}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: 20,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Button
                className="light-grey"
                onClick={cancel}
                label="Cancelar"
                fontSize={14}
                disabled={loading}
              />
              <Button
                className="dark-grey"
                onClick={isNewUser ? create : save}
                label={isNewUser ? 'Crear Usuario' : 'Guardar Datos'}
                fontSize={14}
                disabled={!isDirty || loading}
              />
            </div>
          </div>
        )}
      </>
    )
  )
}

export default ButtonsSection
